module.exports = __webpack_public_path__ + "media/images/icon-profile-e98458a04012eb04f753254e20e481ec.svg";